import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app.js";
import { ToastProvider } from "./components/ui/toast.js";
import { SessionProvider } from "./components/sessionProvider.js";
import { LocaleProvider } from "./i18n/index.js";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root mount element.");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <LocaleProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </LocaleProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>
);
